import { SET_DELIVERY_CHANGE_SETTINGS, SET_DELIVERY_SETTINGS_BEEPER_CONFIGS, SET_DELIVERY_SETTINGS_CART_SETTINGS, UPDATE_DELIVERY_CHANGE_SETTING, UPDATE_DELIVERY_SETTINGS_CART_SETTING } from '../../actionTypes/deliverySettings'

export const setDeliverySettingsCartSettings = value => ({ type: SET_DELIVERY_SETTINGS_CART_SETTINGS, value })

export const updateDeliverySettingsCartSetting = value => ({ type: UPDATE_DELIVERY_SETTINGS_CART_SETTING, value })

export const setDeliverySettingsChangeSettings = value => ({ type: SET_DELIVERY_CHANGE_SETTINGS, value })

export const updateDeliverySettingsChangeSetting = value => ({ type: UPDATE_DELIVERY_CHANGE_SETTING, value })

export const setDeliveryBeeperConfigs = value => ({ type: SET_DELIVERY_SETTINGS_BEEPER_CONFIGS, value })
